import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

import RequestAppliedOffersSkeleton from '../skeleton/request-applied-offers-skeleton';
import { renderAttachment } from '../../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    wideTd: {
        minWidth: `125px`,
        maxWidth: `300px`
    }
});

const VisaAppliedOffers = ({ reloadOffers, reservationReqId }) => {
    const [visaOffers, setVisaOffers] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        setLoading(true);
        axios.get(`/api/visaoffer?reservationReqId=${reservationReqId}`, { headers: headers })
            .then(res => {
                setVisaOffers(res.data);
                setTimeout(() => setLoading(false), 750);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [reloadOffers]);

    return (
        loading ?
            <RequestAppliedOffersSkeleton />
            :
            visaOffers.length > 0 ?
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Offer Headline</TableCell>
                                <TableCell>More Details</TableCell>
                                <TableCell>Destination</TableCell>
                                <TableCell>Create Date</TableCell>
                                <TableCell>From Date</TableCell>
                                <TableCell>To Date</TableCell>
                                <TableCell>Visa Type</TableCell>
                                <TableCell>Visa Entry</TableCell>
                                <TableCell>Processing Days</TableCell>
                                <TableCell>Adult Price</TableCell>
                                <TableCell>Child Price</TableCell>
                                <TableCell>Infant Price</TableCell>
                                <TableCell>Requirements</TableCell>
                                <TableCell>Attachment</TableCell>
                                <TableCell>Notes</TableCell>
                                <TableCell>Created By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                visaOffers ?
                                    visaOffers.map((VisaOffer, index) => (
                                        <Row key={index} row={VisaOffer} />
                                    )) :
                                    null
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <>
                    You haven't applied any offers for this request.
                </>
    );
}

const Row = ({ row }) => {
    const classes = useRowStyles();
    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell component="th" scope="row" className={classes.wideTd}>
                    {row.offerHeadline}
                </TableCell>
                <TableCell>
                    <Link to={`/offer/visa/${row.id}`}><OpenInNewOutlinedIcon /></Link>
                </TableCell>
                <TableCell>
                    {row.destinationName}
                </TableCell>
                <TableCell className={classes.wideTd}>{row.createDate.replace('T', ' ').substring(0, 16)}</TableCell>
                <TableCell>{row.fromDate.substring(0, 10)}</TableCell>
                <TableCell>{row.toDate.substring(0, 10)}</TableCell>
                <TableCell>{row.visaType1}</TableCell>
                <TableCell>{row.entriesNumber}</TableCell>
                <TableCell>{row.processingDays}</TableCell>
                <TableCell>{row.adultPrice}</TableCell>
                <TableCell>{row.childPrice}</TableCell>
                <TableCell>{row.infantPrice}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.VisaRequirements}</TableCell>
                <TableCell className={classes.wideTd}>
                    {renderAttachment(row.attachment)}
                </TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.notes}</TableCell>
                <TableCell className={classes.wideTd}>{row.createdBy}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}


export default VisaAppliedOffers;